import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=1e66820e&scoped=true&"
import script from "./AddCustomer.vue?vue&type=script&lang=js&"
export * from "./AddCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=1e66820e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e66820e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e66820e')) {
      api.createRecord('1e66820e', component.options)
    } else {
      api.reload('1e66820e', component.options)
    }
    module.hot.accept("./AddCustomer.vue?vue&type=template&id=1e66820e&scoped=true&", function () {
      api.rerender('1e66820e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/customerService/modules/AddCustomer.vue"
export default component.exports